import { render } from "./editCreateModal.vue?vue&type=template&id=ed6151a8&scoped=true"
import script from "./editCreateModal.vue?vue&type=script&lang=js"
export * from "./editCreateModal.vue?vue&type=script&lang=js"

import "./editCreateModal.vue?vue&type=style&index=0&id=ed6151a8&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6151a8"]])

export default __exports__